import React, { useState } from "react";
import styled from "styled-components/macro";
import {
  Label,
  Input,
  ViewPasswordEye,
} from "../../../styles/StyledComponents";
import Asterix from "../../../assets/asterix.svg";
import { formatPhoneNumber } from "../../../util/functions";
import { formatNameField } from "../../../util/validators";
import { useTranslation } from "react-i18next";
import { eye } from "../../../assets/components/svgs";
import { SpinnerIconWrapper } from "../../primitives/inputs/BISearchAndClick";
import { useLocalization } from "../../../hooks/useLocalization";

interface NewOrganizationSampleData {
  name?: string;
  phone?: string;
  fax?: string;
  address?: string;
  city?: string;
  zip?: string;
  state?: string;
  country?: string;
  roleName?: string;
  createdBy?: string;
}

interface InputFieldProps {
  type: string;
  title?: string;
  id: string;
  key?: string;
  label: string;
  placeholder: any;
  required: boolean;
  value: any;
  onChange: Function;
  error: any;
  asterixFirst?: boolean;
  disabled?: boolean;
  className?: string;
  handleChange?: Function | null;
  onBlurhandler?: Function | null;
  min?: number;
  max?: number;
  autoComplete?: string;
  errorClass?: string;
  disableLabel?: boolean;
  validateField?: boolean;
  onClick?: Function | null;
  ref?: any;
  style?: any;
  step?: number;
  outline?: boolean;
  allowSplChar?: boolean;
  prefixValue?: string;
  isLoading?: boolean;
  suffixValue?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
  readOnly?: boolean;
  layout?: string;
}
const Image = styled.img`
  width: 8px;
  height: 8px;
`;

const ErrorLabel = styled.span`
  fontsize: 11px;
  color: red;
`;

const ViewErrorContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: right;
  margin-left: auto;
  top: 28px;
  margin-right: 10px;
  right: 0;
`;
function InputField({
  type,
  id,
  label,
  placeholder,
  required,
  value,
  onChange,
  error,
  asterixFirst,
  disabled,
  className,
  handleChange = null,
  onBlurhandler = null,
  min = 0,
  max = 0,
  autoComplete = "",
  errorClass = "",
  disableLabel = false,
  validateField = true,
  onClick,
  ref,
  style = {},
  outline = false,
  allowSplChar = false,
  title = "",
  prefixValue = "",
  isLoading = false,
  suffixValue,
  onKeyDown,
  onBlur,
  onFocus,
  autoFocus,
  readOnly,
  layout,
}: InputFieldProps) {
  const { t } = useTranslation();
  const { getRTLLayout } = useLocalization();
  const rtlClasses = getRTLLayout();
  const [viewPassword, setViewPassword] = useState<boolean>(false);
  let inputProps: any = {};
  if (min) {
    inputProps.minLength = min;
  }
  if (max) {
    inputProps.maxLength = max;
  }
  if (autoComplete) {
    inputProps.autoComplete = autoComplete;
  }
  return (
    <>
      {!disableLabel && (
        <Label>
          {asterixFirst && required ? (
            <Image src={Asterix} className={rtlClasses.marginRight("1")} />
          ) : (
            ""
          )}
          {t(label)}
          {!asterixFirst && required ? (
            <Image src={Asterix} className={rtlClasses.marginLeft("1")} />
          ) : (
            ""
          )}
        </Label>
      )}

      <div className="flex w-full flex-row">
        {prefixValue ? (
          <Input
            title={title}
            className={className ? `${className} w-1/4` : "w-1/4"}
            type="text"
            id={`${id}-prefix`}
            placeholder={t(placeholder) || ""}
            required={true}
            style={style || {}}
            outline={outline}
            value={prefixValue}
            disabled={true}
          />
        ) : (
          ""
        )}
        <Input
          title={title}
          className={
            className
              ? `${className} ${prefixValue && rtlClasses.marginLeft("2")} w-full`
              : `${prefixValue && rtlClasses.marginLeft("2")} w-full`
          }
          type={viewPassword ? "text" : type}
          id={id}
          ref={ref}
          data-testid={"input-field"}
          placeholder={t(placeholder) || ""}
          required={required}
          style={style || {}}
          outline={outline}
          value={value}
          onBlur={(e: any) => {
            if (onBlurhandler) {
              onBlurhandler(e);
            }
          }}
          onClick={(e: any) => {
            if (onClick) {
              onClick(e);
            }
          }}
          onChange={(e: any) => {
            onChange(e.target.value);
          }}
          disabled={disabled} //(fieldKey === 'type' ? true : false) || disabled
          {...inputProps}
        />
        {isLoading ? (
          <SpinnerIconWrapper className="absolute right-3 mt-2.5 bg-white"></SpinnerIconWrapper>
        ) : (
          ""
        )}
      </div>

      {type === "password" && (
        <ViewErrorContainer>
          <ViewPasswordEye
            onClick={() => {
              setViewPassword(!viewPassword);
            }}
          >
            <div className="m-auto w-fit">{eye}</div>
            <div className="-mt-[7px]	select-none">
              {viewPassword ? "hide" : "view"}
            </div>
          </ViewPasswordEye>
        </ViewErrorContainer>
      )}

      <ErrorLabel className={errorClass}>{error ? error : ""}</ErrorLabel>
    </>
  );
}

export default InputField;
